import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import numeral from 'numeral';
import Modal from 'react-modal';

import useLockedScreen from 'lib/hooks/useLockedScreen';
import { BaseButton } from 'components/Shared/Buttons';

export interface VehicleNotFoundDialogProps {
  listingsCount: number;
  isInitiallyShown?: boolean;
}

const closeModalStyles: ReactModal.Styles = {
  content: {
    height: 222,
    width: 280,
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    overflow: 'hidden',
    padding: 0,
  },
  overlay: {
    zIndex: 1000,
    overflow: 'hidden',
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
};

export default function VehicleNotFoundDialog(props: VehicleNotFoundDialogProps): JSX.Element {
  const [isShown, setIsShown] = useState(!!props.isInitiallyShown);
  function close(): void {
    setIsShown(false);
  }
  const { t } = useTranslation();
  useLockedScreen(isShown);

  return (
    <>
      <Modal
        isOpen={isShown}
        onRequestClose={close}
        shouldCloseOnOverlayClick={true}
        style={closeModalStyles}
      >
        <div className="content">
          <p className="primary-message">{t('srp.vehicleNotFound.primaryMessage')}</p>

          {props.listingsCount > 0 && (
            <p className="secondary-message">
              <Trans
                i18nKey="srp.vehicleNotFound.secondaryMessage"
                values={{ listingsCount: numeral(props.listingsCount).format('0,0') }}
                components={[<span className="listings-count" />]}
              />
            </p>
          )}
          <BaseButton
            normalText={t('srp.vehicleNotFound.confirm')}
            aria-label="vehicle-not-found-dialog-confirm-button"
            onClick={close}
            style={{
              width: '100%',
              borderRadius: '4px',
              textTransform: 'uppercase',
              height: '44px',
              fontSize: '16px',
              fontWeight: 600,
            }}
          />
        </div>
      </Modal>
      <style jsx>{`
        .content {
          width: 280px;
          padding: 16px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .primary-message {
          font-size: 18px;
          text-align: center;
          font-weight: 700;
          margin-bottom: 12px;
          width: 232px;
          padding: 0 6px;
        }
        .secondary-message {
          font-size: 16px;
          text-align: center;
          margin-bottom: 36px;
          width: 232px;
          padding: 0 6px;
        }
        .listings-count {
          font-weight: bold;
        }
      `}</style>
    </>
  );
}
